import { ConsumerInterface, ConsumerMetaInterface } from '@interface/consumer/consumer.interface';
import { BaseStoreInterface } from '@interface/store/base-store.interface';
import { BaseStoreStructure } from '@util/constants/store.constants';

export const initialConsumersState: BaseStoreInterface<Record<string, ConsumerInterface>, ConsumerMetaInterface> = {
  ...BaseStoreStructure,
  data: {},
  meta: {
    accessToken: '',
  },
};
